import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { handleKeyDown } from "../../blueplanitUtils/DatePickerAutoformate";
import { message } from "antd";
import { handleDeleteItem } from "./HandleDeleteFunction";
import { setEducationDatas } from "../../Slices/employeeslice";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../blueplanitUtils/Modal";
import { InputField, DatePickerField, SelectInput } from "../../blueplanitUtils/InputField";
import { useFormHandler } from "../../blueplanitUtils/EmployeeSubmitFun";
import { handleClose } from "./HandleClosePop/handleclose"
import { getOptionsByPath } from "../../utilsdata";
import { EDUCATION_INFO,EDUCATION_LEVEL } from "../../Dropdownmanager";
export const EducationalModelPopUp = () => {

  const { handleSubmit } = useFormHandler()
  const dispatch = useDispatch();
  const [isEducationFormValid, setIsEducationFormValid] = useState(false);
  const [educationErrors, setEducationErrors] = useState({});
  const [educationData, setEducationData] = useState([]);
  const Education = useSelector((state) => state.employee.educationData);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);


  const validateEducation = (education) => {
    let errors = {};
    const textRegex = /^[A-Za-z\s-]+$/;
    if (isEducationFormValid) {
      ["educationLevel", "college", "university", "current", "Others", "degree", "fieldOfStudy", "typeOfStudy"].forEach((field) => {
        const value = education[field]?.trim();

        if (education.current === 'pursuing') {
          education.to = null
        }
        if (field === "Others" && education.educationLevel !== "Others") return;

        if (!value) {
          errors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
        } else if (
          field !== "current" &&
          field !== "educationLevel" &&
          !textRegex.test(value)
        ) {
          errors[field] = `${field.replace(/([A-Z])/g, " $1")} must contain only letters.`;
        } else {
          delete errors[field]
        }
      });
      const fromDate = education.from ? new Date(education.from) : null;
      const toDate = education.to ? new Date(education.to) : null;
      const currentYear = new Date().getFullYear();

      if (!education.from) {
        errors.from = "From Date is required.";
      } else {
        const fromDate = new Date(education.from);
        const currentYear = new Date().getFullYear();

        if (fromDate.getFullYear() >= currentYear) {

          errors.from = "From Date cannot be this year or later.";
        } else if (fromDate.getFullYear() < currentYear - 50) {
          errors.from = "From Date is too far in the past.";
        }
      }
      if (!education.to && education.current === 'completed') {
        errors.to = "To Date is required.";
      } else if (toDate?.getFullYear() > currentYear + 1) {
        errors.to = `To Date cannot be later than next year (${currentYear + 1}).`;
      } else if (fromDate && toDate && fromDate > toDate) {
        errors.to = "To Date cannot be earlier than From Date.";
      } else {
        const yearDifference = toDate?.getFullYear() - fromDate?.getFullYear();
        if (yearDifference < 1) {
          errors.to = "The duration should be at least 1 year.";
        } else if (yearDifference > 5) {
          errors.to = "The duration should not exceed 5 years.";
        }
      }
    }
    return errors;
  };


  const EducationhandleInputChange = (index, e, fieldName = null) => {
    let name, value;

    if (e && e.target) {
      name = e.target.name;
      value = e.target.value;
    } else if (fieldName && e instanceof Date) {
      name = fieldName;
      value = e.toISOString().split("T")[0];
    } else {
      return;
    }

    const updatedEducationData = [...educationData];
    updatedEducationData[index] = { ...updatedEducationData[index], [name]: value };
    setEducationData(updatedEducationData);

    const updatedErrors = { ...educationErrors };
    const educationErrorsForIndex = validateEducation(updatedEducationData[index]);

    if (Object.keys(educationErrorsForIndex).length > 0) {
      updatedErrors[index] = educationErrorsForIndex;
    } else {
      delete updatedErrors[index];
    }

    setEducationErrors(updatedErrors);

    const allFieldsValid = updatedEducationData.every((education) => {
      return Object.keys(validateEducation(education)).length === 0;
    });

    setIsEducationFormValid(allFieldsValid);
  };


  const addEducation = () => {
    const newEducation = {
      degree: "",
      university: "",
      from: "",
      to: "",
    };

    setEducationData((prev) => [...prev, newEducation]);
    setIsEducationFormValid(false);
  };

  const deleteEducation = (index) => {
    handleDeleteItem(index, educationData, setEducationData, educationErrors, setEducationErrors, setIsEducationFormValid);
  };
  const EducationhandleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = { ...educationErrors };

    const pursuingCount = educationData.filter(ed => ed.current === 'pursuing').length;

    educationData.forEach((education, index) => {
      const errors = validateEducation(education);

      if (education.current === 'pursuing' && pursuingCount > 1) {
        errors.current = "Only one education entry can be marked as 'pursuing'.";
      }

      if (Object.keys(errors).length > 0) {
        newErrors[index] = errors;
      }
    });

    setEducationErrors(newErrors);
    const formattedEducationData = educationData.map(({ __typename, ...education }) => education);
    const noErrors = Object.keys(newErrors).every((index) => Object.keys(newErrors[index]).length === 0);
    const input = { education: formattedEducationData }

    try {
      const val = await handleSubmit({
        noErrors,
        formValid: isEducationFormValid,
        dataObj: input,
        action: "EducationHistory",
        ModalName: "EducationModelpopUp",
        submitAction: "handleEducationSubmit",
      });

      if (val) {
        dispatch(setEducationDatas(formattedEducationData));
        setIsEducationFormValid(false);
      }
    } catch (error) {
      message.error({
        content: "Failed to update education. Please try again.",
        duration: 5,
        className: "custom-toast-center",
      });
    } finally {
      setIsEducationFormValid(false);
    }
  };


  useEffect(() => {
    setEducationData(Education);
  }, [Education])

  const isPursuingAlreadySelected = educationData.some((ed, i) => ed.current === "pursuing");

  const currentOptions = [
    { label: "completed", value: "completed" },
    ...(!isPursuingAlreadySelected ? [{ label: "  pursuing", value: "pursuing" }] : []),
  ];

  return (
    <Modal
      id="education_info"
      title="Educational Information"
      handleSubmit={EducationhandleSubmit}
      handleModalClose={() =>
        handleClose(Education,
          setEducationData,
          setEducationErrors,
          setIsEducationFormValid)}
      isUserDataValid={false}
    >
      <div className="form-scroll">
        {Array.isArray(educationData) && educationData.map((education, index) => (
          <div className="card" key={index}>
            <div className="card-body">
              <h3 className="card-title">
                Educational Information {index + 1}
                <Link to="#" className="delete-icon" onClick={() => deleteEducation(index)}>
                  <i className="fa-regular fa-trash-can" />
                </Link>
              </h3>

              <div className="row">
                <div className="col-md-6 ">
                  <SelectInput
                    label="Education Level"
                    name="educationLevel"
                    value={education?.educationLevel}
                    onChange={(e) =>
                      EducationhandleInputChange(index, {
                        target: {
                          name: "educationLevel",
                          value: e,
                        }
                      })
                    }
                    formControl={true}
                    options={getOptionsByPath(NestedDatabucket, [EDUCATION_INFO, EDUCATION_LEVEL])}
                    style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                    error={educationErrors?.[index]?.educationLevel}
                  />
                  {education?.educationLevel === 'Others' ? <div className="col-md-12 mb-4">

                    <InputField
                      formcontrol="form-control"
                      required={true}
                      type="text"
                      label="Others"
                      name="Others"
                      placeholder="Others"
                      value={education?.Others || ''}
                      onChange={(e) => EducationhandleInputChange(index, e)}
                      error={educationErrors?.[index]?.Others}
                    />
                  </div> : null}
                </div>
                <div className="col-md-6 mb-2">
                  <InputField
                    formcontrol="form-control"
                    required={true}
                    type="text"
                    label="College/School"
                    name="college"
                    value={education?.college || ''}
                    onChange={(e) => EducationhandleInputChange(index, e)}
                    error={educationErrors?.[index]?.college}
                  />

                </div>

                <div className="col-md-6 mb-2">
                  <InputField
                    formcontrol="form-control"
                    required={true}
                    type="text"
                    label="University/Board"
                    name="university"
                    value={education?.university || ''}
                    onChange={(e) => EducationhandleInputChange(index, e)}
                    error={educationErrors?.[index]?.university}
                  />
                </div>

                <div className="col-md-6 mb-2">
                  <InputField
                    formcontrol="form-control"
                    required={true}
                    type="text"
                    label="Degree"
                    name="degree"
                    value={education?.degree || ''}
                    onChange={(e) => EducationhandleInputChange(index, e)}
                    error={educationErrors?.[index]?.degree}
                  />
                </div>

                <div className="col-md-6 mb-2">
                  <InputField
                    formcontrol="form-control"
                    required={true}
                    type="text"
                    label="Field of Study"
                    name="fieldOfStudy"
                    value={education?.fieldOfStudy || ''}
                    onChange={(e) => EducationhandleInputChange(index, e)}
                    error={educationErrors?.[index]?.fieldOfStudy}
                  />
                </div>

                <div className="col-md-6 mb-2">
                  <InputField
                    formcontrol="form-control"
                    required={true}
                    type="text"
                    label="Type of Study"
                    name="typeOfStudy"
                    value={education?.typeOfStudy || ''}
                    onChange={(e) => EducationhandleInputChange(index, e)}
                    error={educationErrors?.[index]?.typeOfStudy}
                  />
                </div>

                <div className="col-md-6 mb-2">
                  <DatePickerField
                    formcontrol="form-control"
                    required={true}
                    label="start Date"
                    name="from"
                    value={education?.from ? dayjs(education.from) : null}
                    onChange={(date) => {
                      const isoString = date ? date.toISOString() : null;
                      EducationhandleInputChange(index, { target: { name: "from", value: isoString } });
                    }}
                    error={educationErrors?.[index]?.from}
                    onKeyDown={handleKeyDown}
                    format="DD/MM/YYYY"
                    style={{ width: "100%" }}
                    getPopupContainer={(trigger) => trigger.parentElement}
                    onFocus={(e) => e.preventDefault()}
                    autoFocus={false}
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <SelectInput
                    label="currently pursuing"
                    name="current"
                    value={education?.current}
                    onChange={(e) =>
                      EducationhandleInputChange(index, {
                        target: {
                          name: "current",
                          value: e,
                        }
                      })
                    }
                    options={currentOptions}
                    formControl={true}
                    style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                    error={educationErrors?.[index]?.current}
                    required={true}
                  />
                </div>
                {education?.current === 'completed' && <div className="col-md-6 mb-4">
                  <DatePickerField
                    formcontrol="form-control"
                    required={true}
                    label="Completed Date"
                    name="to"
                    value={education?.to ? dayjs(education.to) : null}
                    onChange={(date) => {
                      const isoString = date ? date.toISOString() : null;
                      EducationhandleInputChange(index, { target: { name: "to", value: isoString } });
                    }}
                    format="DD/MM/YYYY"
                    onKeyDown={handleKeyDown}
                    placeholderText="dd/MM/YYYY"
                    error={educationErrors?.[index]?.to}
                    className="form-control"
                    style={{ width: "100%" }}
                    getPopupContainer={(trigger) => trigger.parentElement} // Prevents form from moving
                    onFocus={(e) => e.preventDefault()} // Stops auto-scroll on focus
                    autoFocus={false}
                  />
                </div>}
              </div>
            </div>
          </div>
        ))}
      </div>

      {educationData[educationData?.length - 1]?.current === 'completed' || educationData?.length === 0 ? <div className="add-more">
        <Link to="#" onClick={addEducation}>
          <i className="fa-solid fa-plus-circle" /> Add More
        </Link>
      </div> : null}
    </Modal>

  )
}